<template>
  <v-dialog v-model="is_visible" max-width="290">
    <v-card>
      <v-card-title class="headline">{{dialog_title}}</v-card-title>
      <v-card-text>{{dialog_body}}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="ok">{{btn_ok_text}}</v-btn>
        <v-btn dark @click="cancel">{{btn_cancel_text}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'MessageDialog',
  props: {
    dialog_title: {
      type: String,
      required: true,
    },
    dialog_body: {
      type: String,
      required: true,
    },
    btn_ok_text: {
      type: String,
      required: true,
    },
    btn_cancel_text: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      is_visible: false,
      is_click: false,
    };
  },
  methods: {
    ok() {
      this.is_click = true;
      this.is_visible = false;
      this.$emit('result', true);
    },
    cancel() {
      this.is_click = true;
      this.is_visible = false;
      this.$emit('result', false);
    },
  },
  watch: {
    show(visible) {
      this.is_visible = visible;
    },
    is_visible(visible) {
      if (!visible) {
        if (!this.is_click) this.$emit('result', false);
        else this.is_click = false;
      }
    },
  },
};
</script>
